var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgInventarioFlora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ilus_inventario_de_flora",
    "data-name": "ilus_inventario de flora",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 424.381,
    height: 333.441,
    viewBox: "0 0 424.381 333.441",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_134",
    "data-name": "Rect\\xE1ngulo 134",
    width: 424.381,
    height: 333.441,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_287",
    "data-name": "Grupo 287"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286",
    "data-name": "Grupo 286",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1430",
    "data-name": "Trazado 1430",
    d: "M6.3,158.287,244.209,5.508l131.473,112.9L136.964,271.529Z",
    transform: "translate(7.171 6.272)",
    fill: "#756455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1431",
    "data-name": "Trazado 1431",
    d: "M22.713,143.723l95.844,89.047L327.4,103.607l-101.548-85.1Z",
    transform: "translate(25.864 21.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1432",
    "data-name": "Trazado 1432",
    d: "M39.455,67.553,31.67,83.112l99.114,86.88,16.355-10.664Z",
    transform: "translate(36.064 76.926)",
    fill: "#8b7f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1433",
    "data-name": "Trazado 1433",
    d: "M132.938,161.708l-4.051,1.347L29.778,76.174l4.047-1.345Z",
    transform: "translate(33.909 85.21)",
    fill: "#5c4d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1434",
    "data-name": "Trazado 1434",
    d: "M61.525,54.541,53.738,70.1l99.116,86.88,16.353-10.664Z",
    transform: "translate(61.194 62.109)",
    fill: "#8b7f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1435",
    "data-name": "Trazado 1435",
    d: "M155.008,148.7l-4.053,1.35L51.847,63.163l4.044-1.347Z",
    transform: "translate(59.041 70.392)",
    fill: "#5c4d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1436",
    "data-name": "Trazado 1436",
    d: "M80.748,42.534,72.961,58.091l99.116,86.882L188.43,134.31Z",
    transform: "translate(83.084 48.436)",
    fill: "#8b7f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1437",
    "data-name": "Trazado 1437",
    d: "M174.23,136.691l-4.053,1.347L71.07,51.156l4.044-1.347Z",
    transform: "translate(80.931 56.72)",
    fill: "#5c4d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1438",
    "data-name": "Trazado 1438",
    d: "M97.36,30.907,89.575,46.465l99.116,86.882,16.353-10.664Z",
    transform: "translate(102.003 35.196)",
    fill: "#8b7f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1439",
    "data-name": "Trazado 1439",
    d: "M190.846,125.064l-4.053,1.347L87.683,39.529l4.046-1.347Z",
    transform: "translate(99.849 43.479)",
    fill: "#5c4d44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1440",
    "data-name": "Trazado 1440",
    d: "M116.938,20.069l-7.785,15.559,99.114,86.88,16.353-10.664Z",
    transform: "translate(124.298 22.854)",
    fill: "#8b7f69"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1441",
    "data-name": "Trazado 1441",
    d: "M210.422,114.225l-4.053,1.347L107.261,28.69l4.047-1.345Z",
    transform: "translate(122.143 31.139)",
    fill: "#5c4d44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_285",
    "data-name": "Grupo 285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_284",
    "data-name": "Grupo 284",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1442",
    "data-name": "Trazado 1442",
    d: "M66.964,210.134C69.909,209.777,306.6,58.3,306.6,58.3l-.826,42.082L66.964,254.188Z",
    transform: "translate(76.255 66.384)",
    fill: "#5f5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1443",
    "data-name": "Trazado 1443",
    d: "M6.3,76.941v35.892L136.048,232.955l.915-42.771Z",
    transform: "translate(7.171 87.617)",
    fill: "#483932"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1444",
    "data-name": "Trazado 1444",
    d: "M29.554,166.495l12.311,12.3L263.049,36.867,249.682,25.215Z",
    transform: "translate(33.654 28.714)",
    fill: "#b8a588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1445",
    "data-name": "Trazado 1445",
    d: "M256.495,30.663v4.271L35.31,176.853v-4.267Z",
    transform: "translate(40.209 34.918)",
    fill: "#8a7165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1446",
    "data-name": "Trazado 1446",
    d: "M29.554,91.272v5.242l12.311,11.744v-4.69Z",
    transform: "translate(33.654 103.936)",
    fill: "#5f5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1447",
    "data-name": "Trazado 1447",
    d: "M16.371,155.022l12.308,12.3L249.865,25.395,236.5,13.743Z",
    transform: "translate(18.643 15.65)",
    fill: "#b8a588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1448",
    "data-name": "Trazado 1448",
    d: "M243.311,19.191v4.271L22.126,165.38v-4.265Z",
    transform: "translate(25.196 21.853)",
    fill: "#8a7165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1449",
    "data-name": "Trazado 1449",
    d: "M16.371,79.8v5.244L28.68,96.788V92.1Z",
    transform: "translate(18.643 90.872)",
    fill: "#5f5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1450",
    "data-name": "Trazado 1450",
    d: "M43.784,178.806l13.031,11.832L277.383,48.977l-13.431-11.4Z",
    transform: "translate(49.859 42.787)",
    fill: "#b8a588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1451",
    "data-name": "Trazado 1451",
    d: "M270.444,42.905v4.406L49.877,188.969v-4.4Z",
    transform: "translate(56.797 48.858)",
    fill: "#8a7165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1452",
    "data-name": "Trazado 1452",
    d: "M43.784,103.608l.336,5.069,12.7,11.166v-4.4Z",
    transform: "translate(49.859 117.984)",
    fill: "#5f5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1453",
    "data-name": "Trazado 1453",
    d: "M58.851,193.512l13.442,11.541L294.008,62.911,280.4,51.249Z",
    transform: "translate(67.016 58.359)",
    fill: "#b8a588"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1454",
    "data-name": "Trazado 1454",
    d: "M286.851,56.7v4.147L65.455,202.9l-.319-4.059Z",
    transform: "translate(74.173 64.568)",
    fill: "#8a7165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1455",
    "data-name": "Trazado 1455",
    d: "M58.851,117.766v3.927l13.763,11.673-.321-4.059Z",
    transform: "translate(67.016 134.105)",
    fill: "#5f5346"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1456",
    "data-name": "Trazado 1456",
    d: "M154.863,215.771l-2.857-40.228-8.065-11.821L31.628,75.972l16.438-10.9,111.548,88.093,7.68,11.6,2.325,41.5Z",
    transform: "translate(36.017 74.104)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1457",
    "data-name": "Trazado 1457",
    d: "M218.11,176.211l-.86-41.915-6.378-13.489L103.931,29.97,121.8,18.241,227.8,110.1l7.113,12.736-.434,42.835Z",
    transform: "translate(118.351 20.771)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1458",
    "data-name": "Trazado 1458",
    d: "M131.8,21.865l-24.238-4.836L92.6,26.739l21.052,6.575Z",
    transform: "translate(105.445 19.392)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1459",
    "data-name": "Trazado 1459",
    d: "M58.871,68.729,34.632,63.891,19.667,73.6l21.054,6.575Z",
    transform: "translate(22.396 72.756)",
    fill: "#1a1818"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgInventarioFlora);
export default __webpack_public_path__ + "static/media/img_inventario_flora.0bc9b39b8be38b8e0ff330d5d208052a.svg";
export { ForwardRef as ReactComponent };